import React from "react";
import "../styles/GraduateTrainingDetails.scss";

const TermsOfUseDetails = () => {
  return (
    <section className="space graduate-details">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-10 col-lg-11">
            <div className="graduate-card">
              <h2 className="graduate-main-title">Terms of Use</h2>
              <p>
                <strong>Effective Date: January 1, 2026</strong>
              </p>

              <h3 className="graduate-section-title">
                1. Acceptance of Terms and Privacy
              </h3>
              <p>
                By accessing or using{" "}
                <a
                  href="https://www.kiubunifu.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  www.kiubunifu.com
                </a>{" "}
                (&quot;the Website&quot;), you agree to comply with and be bound
                by these Terms of Use and our Privacy Policy. If you do not
                agree to these terms or our Privacy Policy, please refrain from
                using the Website.
              </p>

              <h3 className="graduate-section-title">
                2. Changes to Terms and Privacy Policy
              </h3>
              <p>
                We reserve the right to update or modify these Terms of Use and
                our Privacy Policy at any time. You are responsible for checking
                this page periodically for changes. Your continued use of the
                Website following the posting of changes indicates your
                acceptance of those changes.
              </p>

              <h3 className="graduate-section-title">
                3. Contact Us Form and Data Processing
              </h3>
              <p>
                The Website provides a contact us form for your convenience.
                When you use the contact form, you may be asked to provide
                personal information such as your name and email address. We
                collect and process this data in accordance with our Privacy
                Policy and GDPR requirements.
              </p>

              <h3 className="graduate-section-title">
                4. Data Protection and Privacy
              </h3>
              <p>
                We are committed to protecting your privacy and complying with
                the GDPR. Our Privacy Policy outlines how we collect, use,
                disclose, and safeguard your personal information. By using the
                Website, you consent to the processing of your data as described
                in our Privacy Policy.
              </p>

              <h3 className="graduate-section-title">5. Intellectual Property</h3>
              <p>
                The Website and its original content, features, and
                functionality are owned by Kiubunifu Global Limited and are protected
                by international copyright, trademark, patent, trade secret, and
                other intellectual property or proprietary rights laws.
              </p>

              <h3 className="graduate-section-title">
                6. Limitation of Liability
              </h3>
              <p>
                To the fullest extent permitted by applicable law, Kiubunifu Global Limited shall not be liable for any direct, indirect,
                incidental, special, consequential, or punitive damages, or any
                loss of profits or revenues, whether incurred directly or
                indirectly, resulting from your use of the Website.
              </p>

              <h3 className="graduate-section-title">7. Governing Law</h3>
              <p>
                These Terms of Use and our Privacy Policy are governed by and
                construed in accordance with the laws of [in your jurisdiction],
                without regard to its conflict of law principles.
              </p>

              <h3 className="graduate-section-title">8. Contact Information</h3>
              <p>
                If you have any questions about these Terms of Use, our Privacy
                Policy, or need to exercise your rights under GDPR, please
                contact us through the contact form provided on the Website or
                email us at{" "}
                <a href="mailto:customerservice@kiubunifu.com">customerservice@kiubunifu.com</a> as
                specified in our Privacy Policy.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TermsOfUseDetails;
